import {
  PriorityContactDto,
  PriorityLevel,
} from '@act/shared/data-transfer-objects';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, TableCell, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import styled from 'styled-components';
import { HighlightableRow } from 'toolkit/tables/highlightable-row';
import { StatusTag } from 'toolkit/tags/status-tags';
import { ChipColor, TaggableChip } from '@act/storybook';
import { displayName } from 'utilities/formatters/display-name';

interface ContactSoonRowProps {
  data?: PriorityContactDto;
  openAdditionalMenu?: (
    event: React.MouseEvent<HTMLElement>,
    data: PriorityContactDto
  ) => void;
}

const DivFitContent = styled.div`
  width: fit-content;
`;

const PriorityTag = ({ priority }: { priority: PriorityLevel }) => {
  let label: string;
  let color: ChipColor = 'neutral';
  if (priority === 'high') {
    label = '≤ 3 days';
    color = 'error';
  } else if (priority === 'medium') {
    label = '4-9 days';
    color = 'warning';
  } else if (priority === 'low') {
    label = '10-15 days';
    color = 'success';
  }
  return <TaggableChip label={label} color={color} />;
};

const getPhaseLabel = (phase: string) => {
  if (phase?.length > 1) {
    return phase;
  } else if (phase?.length === 1) {
    return 'Phase ' + phase;
  }
  return '';
};

const ContactSoonTableRow = ({
  data,
  openAdditionalMenu,
}: ContactSoonRowProps) => {
  const member = membersAppSelectors.useSelectMemberById(data.memberId);
  const lastEventString = member?.lastEventAt
    ? DateTime.fromMillis(member?.lastEventAt).toFormat('LLL dd, yyyy')
    : '––';
  return (
    <HighlightableRow>
      <TableCell>
        <Typography variant="bodyMedium">{displayName(member)}</Typography>
      </TableCell>
      <TableCell>
        <DivFitContent>
          <StatusTag status={member?.memberStatus} />
        </DivFitContent>
      </TableCell>
      <TableCell>
        <DivFitContent>
          <Typography variant="bodyMedium">
            {getPhaseLabel(member?.standardMemberAttributes?.outreachPhase)}
          </Typography>
        </DivFitContent>
      </TableCell>
      <TableCell>{lastEventString}</TableCell>
      <TableCell>
        <PriorityTag priority={data.priorityLevel} />
      </TableCell>
      <TableCell>
        <IconButton onClick={e => openAdditionalMenu(e, data)}>
          <MoreVertIcon />
        </IconButton>
      </TableCell>
    </HighlightableRow>
  );
};

export default ContactSoonTableRow;
